import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class WindowHelper {
  private resizeSubject = new BehaviorSubject<number>(window.innerWidth);
  resize$ = this.resizeSubject.asObservable();
  
  constructor() {
      fromEvent(window, 'resize')
          .pipe(debounceTime(200))
          .subscribe(() => {
              this.resizeSubject.next(window.innerWidth);
          });
  }

  getLocationHref(): string {
    return window.location.href;
  }

  getInnerWidth(): number {
    return window.innerWidth;
  }
  
  getInnerHeight(): number {
    return window.innerHeight;
  }

  getScrollTop(): number {
    return window.scrollY;
  }

  reloadPage(): void {
    window.location.reload();
  }
}
